/**
 * Matches a standard email address. The TLD allows 2+ characters (not capped
 * at 4) so newer, longer TLDs such as `.construction` or `.photography` validate correctly.
 */
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
